// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4418dd34","535":"2842dbaa","878":"0f1ef971"}[chunkId] + ".chunk.js";
};